module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"text-danger bg-danger text-center block-danger\">\n            <h3>Permission denied!</h3>\n            <p class=\"message\">\n                You do not have the necessary permissions to view this page.\n            </p>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/permissionDenied.html
// module id = 636
// module chunks = 7